import ClockoutController from './core/clockout.controller';
import { ClockoutContext, ClockoutDataStore, Config, Institution, StyleConfig, User } from '@clockout-dev/clockout-components';

const TVFCU_ROUTING_NUMBER = '261375684';

class AppController extends ClockoutController {
    async initialize() {
        if (this.isAuthenticated) console.log('authenticated');

        let context = {};

        const nonce = this.props.searchParams.get('nonce');

        if (nonce) {
            const contextData = await this.data.fetchContext(nonce);
            if (contextData?.context) {
                context = contextData?.context;
            } else {
                this.setState({ error: true });
                return;
            }
            await this.setClockoutContext(context);
        } else {
            this.setState({ error: true });
            return;
        }
    }

    async setClockoutContext(ctx = {}) {
        const {
            fiName = 'TVFCU',
            routingNumber = TVFCU_ROUTING_NUMBER,
            phoneNumber = '5738582742',
            givenName = 'Michael 2',
            familyName = 'TVFCU',
            logonName = 'michaeljohn',
            email = 'michaeljohn@tvfcu.com',
            ssn = '37462954920',
            apiUrl = 'https://test-tvfcu-api.joinclockout.com',
            identifier = null,
            context = null,
            key = null,
            style = {},
            productName = 'Power Pay',
            accounts = [{ accountNumber: '123456789', type: 'Checking', externalAccountId: '1337' }]
        } = ctx || {};

        ClockoutContext.Instance(
            new Institution(fiName, routingNumber, 'ALKAMI', null, productName),
            new Config(key, null, apiUrl, process.env.REACT_APP_MIXPANEL_TOKEN),
            new ClockoutDataStore(),
            new User({
                phoneNumber: phoneNumber,
                name: `${givenName} ${familyName}`.trim(),
                loginName: logonName,
                ssn: ssn,
                memberId: identifier,
                email: email,
                accounts: accounts,
                context
            }),
            new StyleConfig(style)
        );

        this.setState({ loading: false });
    }
}

export default AppController;
